<template>
  <div>
    <el-drawer v-loading="loading" title="交货单" :visible.sync="show" size="90%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看'|| form.status > 1" :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="交货单号">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SAP交货单号">
                <el-input v-model="form.sapDeliverySn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="单据类型" prop="deliveryType">
                <el-select v-model="form.deliveryType" :disabled="true" placeholder="请选择">
                  <el-option v-for="item in salesTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="销售单号" prop="orderSn">
                <el-input v-model="form.orderSn" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectOrderSn" />
                </el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col v-show="form.deliveryType===2" :span="6">
              <el-form-item label="退货单号" prop="returnOrderSn">
                <el-input v-model="form.returnOrderSn" readonly placeholder="请点击图标选择">
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="selectReturnOrderSn"
                  />
                </el-input>
              </el-form-item>
            </el-col> -->

            <!-- <el-col v-show="form.deliveryType===3" :span="6">
              <el-form-item label="不定价销售单号" prop="orderSn">
                <el-input v-model="form.orderSn" readonly placeholder="请点击图标选择">
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="selectOrderSn"
                  />
                </el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="SAP调仓单号">
                <el-input v-model="form.sapTransferOrder" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SAP销售单号">
                <el-input v-model="form.sapSalesOrderSn" :disabled="true" placeholder="选择单号带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="售达方" prop="soldToPartyName">
                <el-input v-model="form.soldToPartyName" :disabled="true" placeholder="选择单号带出">
                  <!-- <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="selectSoldToParty"
                  /> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="送达方" prop="deliverySideName">
                <el-input v-model="form.deliverySideName" :disabled="true" placeholder="选择单号带出">
                  <!-- <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="selectDeliverySide"
                  /> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- loadTransportSpot -->
              <el-form-item label="装运地点" prop="loadTransportSpotName">
                <el-input v-model="form.loadTransportSpotName" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectLoadTransportSpot" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划发货日期" prop="shipPlansTime">
                <el-date-picker v-model="form.shipPlansTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="财务入帐日期" prop="finalDeliveryTime">
                <el-date-picker v-model="form.finalDeliveryTime" :disabled="form.deliveryType === 3" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col v-if="form.deliveryType === 3" :span="6">
              <el-form-item label="调拨日期" prop="transferDate" :disabled="true">
                <el-date-picker v-model="form.transferDate" type="date" placeholder="自动带出" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="拣配日期" prop="pickingTime">
                <el-date-picker v-model="form.pickingTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据状态" prop="status">
                <el-input v-model="statusArr[form.status]" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="交货工厂" prop="factoryId">
                <el-select v-model="form.factoryId" :disabled="true" placeholder="选择单号带出">
                  <el-option v-for="item in factoryOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中间公司" prop="middleCompanyId">
                <el-input v-model="form.middleCompanyName" :disabled="true" placeholder="选择单号带出">
                  <!-- <el-button slot="append" readonly icon="el-icon-search" @click="selectMiddleCompany" /> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="form.createUser" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间">
                <el-input v-model="form.createTime" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-model="form.note" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="单据日期" prop="orderTime">
                <el-date-picker
                  v-model="form.orderTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-card>
        <el-card header="订单明细">
          <el-tabs v-model="activePaneName">
            <el-tab-pane label="配件" name="mountings">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addMountingsLine()">配件明细</el-button>
                <!-- <el-button type="danger" @click="delectMountingsLine()">一键清空配件列表</el-button> -->
              </div>
              <el-table v-if="!showObj.mountings" ref="mountingsTable" height="400px" :data="form.mountingsList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="qty">
                      <el-input v-model="scope.row.qty" :disabled="true" placeholder="自动生成" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="已交货数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="deliveredQuantity">
                      <el-input v-model="scope.row.deliveredQuantity" :disabled="true" placeholder="自动生成" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="未交货数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="undeliveredQuantity">
                      <el-input v-model="scope.row.undeliveredQuantity" :disabled="true" placeholder="自动生成" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="存储地点" align="left" width="180">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.warehouseCode'
                      " :rules="mountingsList.warehouseCode">
                      <el-input v-model="scope.row.warehouseCode" readonly placeholder="请点击图标选择">
                        <el-button slot="append" icon="el-icon-search" @click="selectWarehouse(scope.$index,scope.row.productType)" />
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="当前交货数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.deliveryQty'
                      " :rules="mountingsList.deliveryQty">
                      <el-input v-model="scope.row.deliveryQty" placeholder="请输入" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="投入数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="inputQty">
                      <el-input v-model="scope.row.inputQty" :disabled="false" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'mountingsList.' + scope.$index + '.taxPrice'
                      "
                      :rules="mountingsList.taxPrice"
                    >
                      <el-input v-model="scope.row.taxPrice" placeholder="请输入" min="0" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleMountingsDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="废料" name="flotsam">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addFlotsamLine()">废料明细</el-button>
                <!-- <el-button type="danger" @click="delectFlotsamLine()">一键清空配件列表</el-button> -->
              </div>
              <el-table v-if="!showObj.flotsam" ref="flotsamTable" height="400px" :data="form.flotsamList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="qty">
                      <el-input v-model="scope.row.qty" :disabled="true" placeholder="自动生成" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="已交货数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="deliveredQuantity">
                      <el-input v-model="scope.row.deliveredQuantity" :disabled="true" placeholder="自动生成" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="未交货数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="undeliveredQuantity">
                      <el-input v-model="scope.row.undeliveredQuantity" :disabled="true" placeholder="自动生成" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="存储地点" align="left" width="180">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.warehouseCode'
                      " :rules="flotsamList.warehouseCode">
                      <el-input v-model="scope.row.warehouseCode" readonly placeholder="请点击图标选择">
                        <el-button slot="append" icon="el-icon-search" @click="selectWarehouse(scope.$index,scope.row.productType)" />
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="当前交货数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.deliveryQty'
                      " :rules="flotsamList.deliveryQty">
                      <el-input v-model="scope.row.deliveryQty" :disabled="scope.row.netWeight" placeholder="请输入" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="磅单重量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="netWeight">
                      <el-button type="text" @click="selectNetWeight(scope.$index)">{{ scope.row.netWeight || '选择磅单' }}</el-button>
                      <el-button v-if="scope.row.netWeight" style="color: #F56C6C;" type="text" @click="cancelNetWeight(scope.$index)">取消引用</el-button>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="投入数量" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="inputQty">
                      <el-input v-model="scope.row.inputQty" :disabled="false" min="0" />
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleFlotsamDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="ZP03投入" name="spareParts">
              <!-- <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addSparePartsLine()">新增</el-button>
                <el-button type="danger" @click="delectSparePartsLine()">一键清空散件列表</el-button>
              </div> -->
              <!--  v-if="!showObj.spareParts" -->
              <el-table ref="sparePartsTable" height="400px" :data="form.crmSalesOrdersLooseItemsModels" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="'crmSalesOrdersLooseItemsModels.' + scope.$index + '.qty' " :rules="crmSalesOrdersLooseItemsModels.qty">
                      <el-input v-model="scope.row.qty" min="0" :disabled="true" placeholder="请输入" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="单价" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item :prop="'crmSalesOrdersLooseItemsModels.' + scope.$index + '.price' " :disabled="true" :rules="crmSalesOrdersLooseItemsModels.price">
                      <el-input v-model="scope.row.price" min="0" placeholder="请输入" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" :disabled="true" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleSparePartsDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <!-- <el-card v-if="form.status != 3" header="流程审批">
          {{ form.flowId }}
          <Flow
            ref="flow"
            :custom-event="true"
            :flow-id="form.flowId"
            @flowLoad="flowLoad"
            @complete="onComplete"
          />
        </el-card> -->
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary" @click="confirmShipment()">确认发货</el-button>
          <!-- <el-button
            v-if="form.id && (form.status == 1 || !form.status)"
            type="primary"
            @click="saveAndSubmit()"
          >提交</el-button> -->
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 售达方 -->
    <el-dialog class="dialog" :title="'选择售达方'" :visible.sync="showObj.soldToParty" width="50%" :before-close="soldToPartyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.soldToParty.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getSoldToPartyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.soldToParty" border height="300" @selection-change="handleSoldToPartySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip width="120" />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip width="120" />
        <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.operateCategory == 1">配件</span>
            <span v-if="scope.row.operateCategory == 2">废钢</span>
            <span v-if="scope.row.operateCategory == 3">有色</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.soldToParty.total" :page.sync="pagination.soldToParty.current" :limit.sync="pagination.soldToParty.size" @pagination="getSoldToPartyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldToPartyClose">取消</el-button>
        <el-button type="primary" @click="soldToPartyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 送达方 -->
    <el-dialog class="dialog" :title="'选择送达方'" :visible.sync="showObj.deliverySide" width="50%" :before-close="deliverySideClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.deliverySide.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getDeliverySideDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.deliverySide" border height="300" @selection-change="handleDeliverySideSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip width="120" />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip width="120" />
        <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.operateCategory == 1">配件</span>
            <span v-if="scope.row.operateCategory == 2">废钢</span>
            <span v-if="scope.row.operateCategory == 3">有色</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.deliverySide.total" :page.sync="pagination.deliverySide.current" :limit.sync="pagination.deliverySide.size" @pagination="getDeliverySideDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliverySideClose">取消</el-button>
        <el-button type="primary" @click="deliverySideConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 中间公司 -->
    <el-dialog class="dialog" :title="'选择中间公司'" :visible.sync="showObj.middleCompany" width="60%" :before-close="middleCompanyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.middleCompany.customerApplyName" clearable placeholder="请输入销售客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMiddleCompanyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.middleCompany" border height="300" @selection-change="handleMiddleCompanySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="销售组织编码" align="left" prop="salesOrganizationCode" show-overflow-tooltip width="120" />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="销售客户" align="left" prop="customerApplyName" show-overflow-tooltip width="150" />
        <el-table-column label="采购组织编码" align="left" prop="purchasingOrganizationCode" show-overflow-tooltip width="120" />
        <el-table-column label="采购组织" align="left" prop="purchasingOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="采购供应商" align="left" prop="supplierName" show-overflow-tooltip width="150" />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.middleCompany.total" :page.sync="pagination.middleCompany.current" :limit.sync="pagination.middleCompany.size" @pagination="getMiddleCompanyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="middleCompanyClose">取消</el-button>
        <el-button type="primary" @click="middleCompanyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 销售单号 -->
    <el-dialog class="dialog" :title="'选择销售单号'" :visible.sync="showObj.orderSn" width="70%" :before-close="orderSnClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="4">
          <el-input v-model="condition.orderSn.sn" clearable placeholder="请输入销售订单号" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="condition.orderSn.soldToPartyName" style="margin-left:5px" clearable placeholder="请输入售达方" />
        </el-col>
        <el-col :span="4">
          <div style="margin-left:5px;width: 1px;" />
          <el-select v-model="condition.orderSn.deliveryType" placeholder="请选择单据类型">
            <el-option v-for="item in salesTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getOrderSnDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.orderSn" border height="300" @selection-change="handleOrderSnSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="订单状态" align="left" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="单据类型"
          align="left"
          prop="salesName"
          show-overflow-tooltip
          width="120"
        /> -->
        <el-table-column label="单据类型" align="left" prop="deliveryType" show-overflow-tooltip width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.deliveryType == 1">交货单</span>
            <span v-if="scope.row.deliveryType == 3">不定价交货单</span>
            <span v-if="scope.row.deliveryType == 2">退货交货单</span>
          </template>
        </el-table-column>
        <el-table-column label="销售订单号" align="left" prop="sn" show-overflow-tooltip width="130">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="addAccessoryDetailLine(scope.row)">{{ scope.row.sn }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="SAP销售单号" align="left" prop="sapOrderSn" width="130" show-overflow-tooltip />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="售达方" align="left" prop="soldToPartyName" show-overflow-tooltip />
        <el-table-column label="送达方" align="left" prop="deliverySideName" show-overflow-tooltip />
        <!-- <el-table-column
          label="交货状态"
          align="left"
          prop=""
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.deliverType == 2">已交货</span>
            <span v-else>未交货</span>

          </template>

        </el-table-column> -->
        <el-table-column label="备注" align="left" prop="note" show-overflow-tooltip />
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.orderSn.total" :page.sync="pagination.orderSn.current" :limit.sync="pagination.orderSn.size" @pagination="getOrderSnDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderSnClose">取消</el-button>
        <el-button type="primary" @click="orderSnConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 退货单号 -->
    <el-dialog class="dialog" :title="'选择退货单号'" :visible.sync="showObj.returnOrderSn" width="70%" :before-close="returnOrderSnClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.returnOrderSn.sn" clearable placeholder="请输入退货单号" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.returnOrderSn.soldToPartyName" style="margin-left:5px" clearable placeholder="请输入售达方" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getOrderSnDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.returnOrderSn" border height="300" @selection-change="handleReturnOrderSnSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="订单状态" align="left" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="单据类型" align="left" prop="salesName" show-overflow-tooltip width="120" />
        <el-table-column label="退货订单号" align="left" prop="sn" show-overflow-tooltip width="130" />
        <el-table-column label="销售订单号" align="left" prop="salesOrderSn" show-overflow-tooltip width="130" />
        <el-table-column label="SAP销售单号" align="left" prop="sapOrderSn" width="130" show-overflow-tooltip />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="售达方" align="left" prop="soldToPartyName" show-overflow-tooltip />
        <el-table-column label="送达方" align="left" prop="deliverySideName" show-overflow-tooltip />
        <!-- <el-table-column
          label="交货状态"
          align="left"
          prop=""
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.deliverType == 2">已交货</span>
            <span v-else>未交货</span>

          </template>

        </el-table-column> -->

        <el-table-column label="备注" align="left" prop="note" show-overflow-tooltip />
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.returnOrderSn.total" :page.sync="pagination.returnOrderSn.current" :limit.sync="pagination.returnOrderSn.size" @pagination="getReturnOrderSnDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnOrderSnClose">取消</el-button>
        <el-button type="primary" @click="returnOrderSnConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 装运地点 -->
    <el-dialog class="dialog" :title="'选择装运地点'" :visible.sync="showObj.loadTransportSpot" width="60%" :before-close="loadTransportSpotClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.loadTransportSpot.loadTransportSpotNumber" clearable placeholder="请输入装运点代码" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getLoadTransportSpotDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.loadTransportSpot" border height="300" @selection-change="handleLoadTransportSpotSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="装运点代码" align="left" prop="loadTransportSpotNumber" show-overflow-tooltip />
        <el-table-column label="装运点描述" align="left" prop="loadTransportSpotName" show-overflow-tooltip />

      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.loadTransportSpot.total" :page.sync="pagination.loadTransportSpot.current" :limit.sync="pagination.loadTransportSpot.size" @pagination="getLoadTransportSpotDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loadTransportSpotClose">取消</el-button>
        <el-button type="primary" @click="loadTransportSpotConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 存储地点 -->
    <el-dialog class="dialog" :title="'选择存储地点'" :visible.sync="showObj.warehouse" width="60%" :before-close="warehouseClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.warehouse.warehouseNumber" clearable placeholder="请输入存储代码" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getWarehouseDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.warehouse" border height="300" @selection-change="handleWarehouseSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="存储代码" align="left" prop="warehouseNumber" show-overflow-tooltip />
        <el-table-column label="存储描述" align="left" prop="warehouseName" show-overflow-tooltip />

      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.warehouse.total" :page.sync="pagination.warehouse.current" :limit.sync="pagination.warehouse.size" @pagination="getWarehouseDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="warehouseClose">取消</el-button>
        <el-button type="primary" @click="warehouseConfirm">确认</el-button>
        <el-button type="primary" @click="allWarehouseConfirm">批量填充</el-button>
      </span>
    </el-dialog>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300" @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="拆解类型" align="left" prop="separateType" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ format.formatEnumDesc('Separate_Type_Code',scope.row.separateType) }}
          </template>
        </el-table-column>
        <el-table-column label="车辆ID" align="left" prop="carId" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <!-- <el-table-column
            label="燃料类型"
            align="left"
            prop="oeCode"
            show-overflow-tooltip
          /> -->
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current" :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品废料 -->
    <el-dialog class="dialog" title="产品废料" :visible.sync="showObj.flotsam" width="60%" :before-close="flotsamClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.flotsam" :data="dialog.flotsam" border height="300" @selection-change="handleFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="未交货数量" align="left" prop="undeliveredQuantity" show-overflow-tooltip />
        <el-table-column label="已交货数量" align="left" prop="deliveredQuantity" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.flotsam.total" :page.sync="pagination.flotsam.current" :limit.sync="pagination.flotsam.size" @pagination="getFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamClose">取消</el-button>
        <el-button type="primary" @click="flotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品明细弹窗 -->
    <el-dialog class="dialog" title="产品明细" :visible.sync="showObj.accessoryDetail" width="70%" :before-close="accessoryDetailClose" destroy-on-close center :close-on-click-modal="false">
      <!-- <el-row>
        <el-col :span="6">
          <el-input v-model="condition.accessoryDetail.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.accessoryDetail.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.accessoryDetail.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.accessoryDetail.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row> -->
      <el-table ref="listTable" v-loading="loadingObj.accessoryDetail" :data="dialog.accessoryDetail" border height="300" @selection-change="handleAccessoryDetailChange">
        <!-- <el-table-column type="selection" width="55" /> -->
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="拆解类型" align="left" prop="separateType" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ format.formatEnumDesc('Separate_Type_Code',scope.row.separateType) }}
          </template>
        </el-table-column>
        <el-table-column label="车辆ID" align="left" prop="carId" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <!-- <el-table-column
            label="燃料类型"
            align="left"
            prop="oeCode"
            show-overflow-tooltip
          /> -->
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.accessoryDetail.total" :page.sync="pagination.accessoryDetail.current" :limit.sync="pagination.accessoryDetail.size" @pagination="getAccessoryDetail" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accessoryDetailClose">关闭</el-button>
        <!-- <el-button type="primary" @click="accessoryDetailConfirm">确认</el-button> -->
      </span>
    </el-dialog>
    <!-- 磅单重量 -->
    <el-dialog class="dialog" :title="'选择磅单重量'" :visible.sync="showObj.netWeight" width="70%" :before-close="netWeightClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.netWeight.sn" clearable placeholder="请输入磅单号" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.netWeight.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.netWeight.carTypeItemName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="condition.netWeight.weighDate" type="datetime" placeholder="选择过磅日期" value-format="yyyy-MM-dd HH:mm:ss" />

        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNetWeightDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.netWeight" border height="300" @selection-change="handleNetWeightSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="磅单号" align="left" prop="sn" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" show-overflow-tooltip />
        <el-table-column label="物料" align="left" prop="carTypeItemName" show-overflow-tooltip />
        <el-table-column label="称重时间" align="left" prop="weighDate" show-overflow-tooltip />
        <el-table-column label="称重人" align="left" prop="weighPersonnel" show-overflow-tooltip />
        <el-table-column label="空重" align="left" prop="weighScaleNull" show-overflow-tooltip />
        <el-table-column label="净重" align="left" prop="weighNet" show-overflow-tooltip />
      </el-table>
      <!-- <el-row class="footer-box">
        <pagination :total="pagination.netWeight.total" :page.sync="pagination.netWeight.current" :limit.sync="pagination.netWeight.size" @pagination="getNetWeightDialog" />
      </el-row> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="netWeightClose">取消</el-button>
        <el-button type="primary" @click="netWeightConfirm">确认</el-button>
        <!-- <el-button type="primary" @click="allNetWeightConfirm">批量填充</el-button> -->
      </span>
    </el-dialog>
  </div>

</template>

<script>
import FileUpload from '@/components/FileUpload/index'
import { getPage as getSalesOrganization } from '@/api/crm/base/salesOrganization'
import { getPage as getFactory } from '@/api/crm/base/factory'
// import { getPage as getSalesOrder } from '@/api/crm/order/salesOrder'
import { getPage as getBusinessType } from '@/api/crm/base/businessTypeDict'
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import {
  get,
  saveOrUpdate,
  getByCustomerApply,
  getByMiddleCompany,
  submit,
  getDetailedDataPopup,
  getReturnDetailsPopup,
  getCompanyInfoFactoryPopupPage,
  getCompanyInfoFactoryListPage,
  confirmShipmentApi,
  getSalesOrder,
  getReturnOrder,
  getUnpricedOrder,
  getUnPricedDetailedPopup,
  queryInvestmentApi,
  getWeightBillApi

} from '@/api/crm/deliver/deliveryNote'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
export default {
  name: 'DeliveryNoteEdit',
  components: {
    Pagination,
    FileUpload,
    Flow
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      salesOrganizationOptions: [],
      channelDistributioOption: [],
      productTeamOption: [],
      businessTypeOptions: [],
      factoryOptions: [],
      loadTransportSpotOptions: [],
      format: format,
      areaData: [],
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        orderSn: null,
        orderId: null,
        sn: null,
        shipPlansTime: format.formatDate(new Date(), 'yyyy-MM-dd'),
        finalDeliveryTime: format.formatDate(new Date(), 'yyyy-MM-dd'),
        pickingTime: format.formatDate(new Date(), 'yyyy-MM-dd'),
        flotsamList: [],
        mountingsList: [],
        soldToPartyName: null,
        loadTransportSpotName: null,
        deliveryType: null,
        status: null,
        returnOrderSn: null,
        returnOrderId: null,
        crmSalesOrdersLooseItemsModels: []
      },
      statusArr: ['', '制单', '审核中', '审核完成'],
      salesTypeOptions: [{ value: 1, label: '发货单' }, { value: 2, label: '退货发货单' }, { value: 3, label: '不定价发货单' }],
      crmSalesOrdersLooseItemsModels: {
        qty: [
          { required: true, message: '散件数量不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '散件单价不能为空', trigger: 'blur' }
        ]
      },
      mountingsList: {
        warehouseCode: [
          { required: true, message: '存储地点不能为空', trigger: 'change' }
        ],
        deliveryQty: [
          { required: true, message: '当前交货数量不能为空', trigger: 'blur' }
        ]
      },
      flotsamList: {
        warehouseCode: [
          { required: true, message: '存储地点不能为空', trigger: 'change' }
        ],
        deliveryQty: [
          { required: true, message: '当前交货数量不能为空', trigger: 'change' }
        ]
      },
      rules: {
        deliveryType: [
          { required: true, message: '单据类型不能为空', trigger: 'change' }
        ],
        orderSn: [
          { required: true, message: '销售单号不能为空', trigger: 'change' }
        ],
        returnOrderSn: [
          { required: true, message: '退货单号不能为空', trigger: 'change' }
        ],
        loadTransportSpotName: [
          { required: true, message: '装运地点不能为空', trigger: 'change' }
        ],
        shipPlansTime: [
          { required: true, message: '计划发货日期不能为空', trigger: 'change' }
        ],
        finalDeliveryTime: [
          { required: true, message: '财务入帐日期不能为空', trigger: 'change' }
        ],
        pickingTime: [
          { required: true, message: '拣配日期不能为空', trigger: 'change' }
        ]
      },
      clientClassOptions: [],
      activePaneName: 'mountings',
      showObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        flotsam: false,
        orderSn: false,
        loadTransportSpot: false,
        warehouse: false,
        returnOrderSn: false,
        accessoryDetail: false,
        netWeight: false
      },
      loadingObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        flotsam: false,
        orderSn: false,
        loadTransportSpot: false,
        warehouse: false,
        returnOrderSn: false,
        accessoryDetail: false,
        netWeight: false
      },
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        soldToParty: {
          total: 0,
          size: 20,
          current: 1
        },
        deliverySide: {
          total: 0,
          size: 20,
          current: 1
        },
        middleCompany: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        orderSn: {
          total: 0,
          size: 20,
          current: 1
        },
        loadTransportSpot: {
          total: 0,
          size: 20,
          current: 1
        },
        warehouse: {
          total: 0,
          size: 20,
          current: 1
        },
        returnOrderSn: {
          total: 0,
          size: 20,
          current: 1
        },
        accessoryDetail: {
          total: 0,
          size: 20,
          current: 1
        },
        netWeight: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        flotsam: [],
        orderSn: [],
        loadTransportSpot: [],
        warehouse: [],
        returnOrderSn: [],
        accessoryDetail: [],
        netWeight: []
      },
      condition: {
        mountings: {},
        soldToParty: {},
        deliverySide: {},
        middleCompany: {},
        flotsam: {},
        orderSn: {},
        loadTransportSpot: {},
        warehouse: {},
        returnOrderSn: {},
        accessoryDetail: {},
        netWeight: {
          // weighDate: format.formatDate(new Date(), 'yyyy-MM-dd') + ' 00:00:00'
          weighDate: '2022-05-07 00:00:00'
        }
      },
      selection: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        flotsam: [],
        orderSn: [],
        loadTransportSpot: [],
        warehouse: [],
        returnOrderSn: [],
        accessoryDetail: [],
        netWeight: []
      },
      isDisabled: false,
      warehouseIndex: null,
      warehouseType: null,
      accessoryDetailList: [],
      accessoryDetail: {},
      netWeightIndex: null
      // { lordDutyPrice: null, taxRatio: null, taxlessPrice: null }
      // mountingsList: [],
      // flotsamList: []
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }

      this.init()
      // console.log(this.form.deliveryType)
      // if (this.form.deliveryType === 2) {
      //   this.rules.returnOrderSn[0].required = true
      //   this.rules.orderSn[0].required = false
      // } else {
      //   this.rules.returnOrderSn[0].required = false
      //   this.rules.orderSn[0].required = true
      // }
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    }
  },
  methods: {
    init() {
      getSalesOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.salesOrganizationOptions = records.map((item) => {
          return {
            label: item.salesOrganizationName,
            value: item.id
          }
        })
      })
      getBusinessType({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.businessTypeOptions = records.map((item) => {
          return {
            label: item.businessTypeName,
            value: item.id
          }
        })
      })
      getFactory({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.factoryOptions = records.map((item) => {
          return {
            label: item.factoryNumber + '-' + item.factoryName,
            value: item.id
          }
        })
      })
      // getCompanyInfoFactoryListPage({}, { current: 1, size: 1000 }).then((response) => {
      //   const { data } = response
      //   this.warehouseOptions = data.map((item) => {
      //     return {
      //       label: item.warehouseNumber + '-' + item.warehouseName,
      //       value: item.id
      //     }
      //   })
      // })
    },
    // 基础数据
    async queryInvestment(id) {
      const res = await queryInvestmentApi({ orderId: id })
      console.log(res)
      this.form.crmSalesOrdersLooseItemsModels = res.data
    },
    // 售达方
    selectSoldToParty() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.soldToParty = true
      this.getSoldToPartyDialog()
    },
    async getSoldToPartyDialog() {
      this.loadingObj.soldToParty = true
      const data = {
        condition: this.condition.soldToParty,
        salesOrganizationId: this.form.salesOrganizationId,
        pagination: this.pagination.soldToParty
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.soldToParty = records
      this.pagination.soldToParty.total = total
      this.pagination.soldToParty.current = current
      this.pagination.soldToParty.size = size
      this.loadingObj.soldToParty = false
    },

    handleSoldToPartySelectionChange(val) {
      this.selection.soldToParty = val
    },
    soldToPartyConfirm() {
      if (this.selection.soldToParty.length > 1) {
        this.$message.warning('只能选择一位售达方！')
      } else {
        this.showObj.soldToParty = false
        this.form.soldToPartyId = this.selection.soldToParty[0].id
        this.form.soldToPartyName = this.selection.soldToParty[0].customerApplyName
      }
    },
    soldToPartyClose() {
      this.showObj.soldToParty = false
    },
    // 送达方
    selectDeliverySide() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.deliverySide = true
      this.getDeliverySideDialog()
    },
    async getDeliverySideDialog() {
      this.loadingObj.deliverySide = true
      const data = {
        condition: this.condition.deliverySide,
        salesOrganizationId: this.form.salesOrganizationId,
        pagination: this.pagination.deliverySide
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.deliverySide = records
      this.pagination.deliverySide.total = total
      this.pagination.deliverySide.current = current
      this.pagination.deliverySide.size = size
      this.loadingObj.deliverySide = false
    },
    handleDeliverySideSelectionChange(val) {
      this.selection.deliverySide = val
    },
    deliverySideConfirm() {
      if (this.selection.deliverySide.length > 1) {
        this.$message.warning('只能选择一位送达方！')
      } else {
        this.showObj.deliverySide = false
        console.log(this.selection.deliverySide)
        this.form.deliverySideId = this.selection.deliverySide[0].id
        this.form.deliverySideName = this.selection.deliverySide[0].customerApplyName
      }
    },
    deliverySideClose() {
      this.showObj.deliverySide = false
    },
    // 中间公司
    selectMiddleCompany() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.middleCompany = true
      this.getMiddleCompanyDialog()
    },
    async getMiddleCompanyDialog() {
      this.loadingObj.middleCompany = true
      const data = {
        customerApplyName: this.condition.middleCompany.customerApplyName,
        salesOrganizationId: this.form.salesOrganizationId,
        pagination: this.pagination.middleCompany
      }
      const reponse = await getByMiddleCompany(data)
      const { current, total, size, records } = reponse.data
      this.dialog.middleCompany = records
      this.pagination.middleCompany.total = total
      this.pagination.middleCompany.current = current
      this.pagination.middleCompany.size = size
      this.loadingObj.middleCompany = false
    },
    handleMiddleCompanySelectionChange(val) {
      this.selection.middleCompany = val
    },
    middleCompanyConfirm() {
      if (this.selection.middleCompany.length > 1) {
        this.$message.warning('只能选择一个中间公司！')
      } else {
        this.showObj.middleCompany = false
        console.log(this.selection.middleCompany)
        this.form.middleCompanyId = this.selection.middleCompany[0].id
        this.form.middleCompanyName = this.selection.middleCompany[0].customerApplyName
      }
    },
    middleCompanyClose() {
      this.showObj.middleCompany = false
    },
    // 销售单号
    selectOrderSn() {
      this.showObj.orderSn = true
      this.getOrderSnDialog()
    },
    async getOrderSnDialog() {
      this.loadingObj.orderSn = true
      this.condition.orderSn.status = 3
      // let reponse = {}
      // 不定价和普通销售订单用同一个方法弹窗
      // if (this.form.deliveryType === 1) {

      // } else if (this.form.deliveryType === 3) {
      //   reponse = await getUnpricedOrder(this.condition.orderSn, this.pagination.orderSn)
      // }
      const reponse = await getSalesOrder(this.condition.orderSn, this.pagination.orderSn)
      const { current, total, size, records } = reponse.data
      this.dialog.orderSn = records
      this.pagination.orderSn.total = total
      this.pagination.orderSn.current = current
      this.pagination.orderSn.size = size
      this.loadingObj.orderSn = false
    },
    handleOrderSnSelectionChange(val) {
      this.selection.orderSn = val
    },
    async orderSnConfirm() {
      if (this.selection.orderSn.length > 1) {
        this.$message.warning('只能选择一个单号！')
      } else {
        this.form = this.$options.data.call(this).form
        this.showObj.orderSn = false
        console.log(this.selection.orderSn)

        this.form.deliveryType = this.selection.orderSn[0].deliveryType
        this.form.orderId = this.selection.orderSn[0].id
        this.form.orderSn = this.selection.orderSn[0].sn
        this.form.sapSalesOrderSn = this.selection.orderSn[0].sapOrderSn
        this.form.soldToPartyId = this.selection.orderSn[0].soldToPartyId
        this.form.soldToPartyName = this.selection.orderSn[0].soldToPartyName
        this.form.deliverySideId = this.selection.orderSn[0].deliverySideId
        this.form.deliverySideName = this.selection.orderSn[0].deliverySideName
        this.form.factoryId = this.selection.orderSn[0].factoryId
        this.form.finalDeliveryTime = this.selection.orderSn[0].finalDeliveryTime ? this.selection.orderSn[0].finalDeliveryTime : format.formatDate(new Date(), 'yyyy-MM-dd')
        this.form.middleCompanyName = this.selection.orderSn[0].middleCompanyName ? this.selection.orderSn[0].middleCompanyName : null
        this.form.middleCompanyId = this.selection.orderSn[0].middleCompanyId ? this.selection.orderSn[0].middleCompanyId : null
        this.form.flotsamList = []
        this.form.mountingsList = []
        if (this.selection.orderSn[0].deliveryType === 2) {
          this.form.returnOrderId = this.selection.orderSn[0].id
          this.form.returnOrderSn = this.selection.orderSn[0].sn
        }
        this.queryInvestment(this.form.orderId)
        // const res = await getDetailedDataPopup({ salesOrderId: this.form.orderId }, { total: 0, size: 200, current: 1 })
        // const deliveryOrderLineModels = res.data.records
        // if (deliveryOrderLineModels && deliveryOrderLineModels.length > 0) {
        //   for (const item of deliveryOrderLineModels) {
        //     if (item.productType === 1) {
        //       this.form.mountingsList.push(item)
        //     } else {
        //       this.form.flotsamList.push(item)
        //     }
        //   }
        // }
      }
    },
    orderSnClose() {
      this.showObj.orderSn = false
    },
    // 退货单号
    selectReturnOrderSn() {
      this.showObj.returnOrderSn = true
      this.getReturnOrderSnDialog()
    },
    async getReturnOrderSnDialog() {
      this.loadingObj.returnOrderSn = true
      this.condition.returnOrderSn.status = 3
      const reponse = await getReturnOrder(this.condition.returnOrderSn, this.pagination.returnOrderSn)
      const { current, total, size, records } = reponse.data
      this.dialog.returnOrderSn = records
      this.pagination.returnOrderSn.total = total
      this.pagination.returnOrderSn.current = current
      this.pagination.returnOrderSn.size = size
      this.loadingObj.returnOrderSn = false
    },
    handleReturnOrderSnSelectionChange(val) {
      this.selection.returnOrderSn = val
    },
    async returnOrderSnConfirm() {
      if (this.selection.returnOrderSn.length > 1) {
        this.$message.warning('只能选择一个退货单号！')
      } else {
        this.showObj.returnOrderSn = false
        this.form.orderId = this.selection.returnOrderSn[0].id
        this.form.returnOrderId = this.selection.returnOrderSn[0].id
        this.form.returnOrderSn = this.selection.returnOrderSn[0].sn
        this.form.sapSalesOrderSn = this.selection.returnOrderSn[0].sapOrderSn
        this.form.soldToPartyId = this.selection.returnOrderSn[0].soldToPartyId
        this.form.soldToPartyName = this.selection.returnOrderSn[0].soldToPartyName
        this.form.deliverySideId = this.selection.returnOrderSn[0].deliverySideId
        this.form.deliverySideName = this.selection.returnOrderSn[0].deliverySideName
        this.form.factoryId = this.selection.returnOrderSn[0].factoryId
        // const res = await getDetailedDataPopup({ salesOrderId: this.form.orderId }, { total: 0, size: 200, current: 1 })
        // const deliveryOrderLineModels = res.data.records
        // if (deliveryOrderLineModels && deliveryOrderLineModels.length > 0) {
        //   for (const item of deliveryOrderLineModels) {
        //     if (item.productType === 1) {
        //       this.form.mountingsList.push(item)
        //     } else {
        //       this.form.flotsamList.push(item)
        //     }
        //   }
        // }
        this.form.mountingsList = []
        this.form.flotsamList = []
      }
    },
    returnOrderSnClose() {
      this.showObj.returnOrderSn = false
    },

    // 装运地点
    selectLoadTransportSpot() {
      this.showObj.loadTransportSpot = true
      this.getLoadTransportSpotDialog()
    },
    async getLoadTransportSpotDialog() {
      this.loadingObj.loadTransportSpot = true
      const reponse = await getCompanyInfoFactoryPopupPage(this.condition.loadTransportSpot, this.pagination.loadTransportSpot)
      const { current, total, size, records } = reponse.data
      this.dialog.loadTransportSpot = records
      this.pagination.loadTransportSpot.total = total
      this.pagination.loadTransportSpot.current = current
      this.pagination.loadTransportSpot.size = size
      this.loadingObj.loadTransportSpot = false
    },
    handleLoadTransportSpotSelectionChange(val) {
      this.selection.loadTransportSpot = val
    },
    loadTransportSpotConfirm() {
      if (this.selection.loadTransportSpot.length > 1) {
        this.$message.warning('只能选择一个装运地点！')
      } else {
        this.showObj.loadTransportSpot = false
        console.log(this.selection.loadTransportSpot)
        this.form.loadTransportSpotId = this.selection.loadTransportSpot[0].id
        //  this.selection.loadTransportSpot[0].loadTransportSpotNumber + '-' +
        this.form.loadTransportSpotName = this.selection.loadTransportSpot[0].loadTransportSpotName
      }
    },
    loadTransportSpotClose() {
      this.showObj.loadTransportSpot = false
    },
    // 存储地点
    selectWarehouse(index, type) {
      this.warehouseIndex = index
      this.warehouseType = type
      this.showObj.warehouse = true
      this.getWarehouseDialog()
    },
    async getWarehouseDialog(type = '') {
      if (type === 'refresh') {
        this.pagination.warehouse.current = 1
      }
      this.loadingObj.warehouse = true
      const reponse = await getCompanyInfoFactoryListPage(this.condition.warehouse, this.pagination.warehouse)
      const { current, total, size, records } = reponse.data
      this.dialog.warehouse = records
      this.pagination.warehouse.total = total
      this.pagination.warehouse.current = current
      this.pagination.warehouse.size = size
      this.loadingObj.warehouse = false
    },
    handleWarehouseSelectionChange(val) {
      this.selection.warehouse = val
    },
    warehouseConfirm() {
      if (this.selection.warehouse.length > 1) {
        this.$message.warning('只能选择一个存储地点！')
      } else {
        this.showObj.warehouse = false
        console.log(this.warehouseType)
        if (this.warehouseType === 1) {
          this.$set(this.form.mountingsList[this.warehouseIndex], 'warehouseCode', this.selection.warehouse[0].warehouseNumber)
          this.$set(this.form.mountingsList[this.warehouseIndex], 'warehouseId', this.selection.warehouse[0].id)
        } else {
          this.$set(this.form.flotsamList[this.warehouseIndex], 'warehouseCode', this.selection.warehouse[0].warehouseNumber)
          this.$set(this.form.flotsamList[this.warehouseIndex], 'warehouseId', this.selection.warehouse[0].id)
        }

        console.log(this.selection.warehouse)
      }
    },
    allWarehouseConfirm() {
      if (this.selection.warehouse.length > 1) {
        this.$message.warning('只能选择一个存储地点！')
      } else {
        this.showObj.warehouse = false
        console.log(this.warehouseType)
        if (this.warehouseType === 1) {
          for (const item of this.form.mountingsList) {
            item.warehouseCode = this.selection.warehouse[0].warehouseNumber
            item.warehouseId = this.selection.warehouse[0].id
            // this.$set(this.form.mountingsList[this.warehouseIndex], 'warehouseCode', this.selection.warehouse[0].warehouseNumber)
            // this.$set(this.form.mountingsList[this.warehouseIndex], 'warehouseId', this.selection.warehouse[0].id)
          }
          const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
          this.$set(this.form, 'mountingsList', arr)
        } else {
          for (const item of this.form.flotsamList) {
            item.warehouseCode = this.selection.warehouse[0].warehouseNumber
            item.warehouseId = this.selection.warehouse[0].id
            // this.$set(this.form.mountingsList[this.warehouseIndex], 'warehouseCode', this.selection.warehouse[0].warehouseNumber)
            // this.$set(this.form.mountingsList[this.warehouseIndex], 'warehouseId', this.selection.warehouse[0].id)
          }
          const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
          this.$set(this.form, 'flotsamList', arr)
          console.log(this.form.flotsamList)
          // this.$set(this.form.flotsamList[this.warehouseIndex], 'warehouseCode', this.selection.warehouse[0].warehouseNumber)
          // this.$set(this.form.flotsamList[this.warehouseIndex], 'warehouseId', this.selection.warehouse[0].id)
        }
      }
    },
    warehouseClose() {
      this.showObj.warehouse = false
    },

    // 配件
    addMountingsLine() {
      if (!this.form.orderId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售单号'
        })
        return
      }
      this.showObj.mountings = true
      this.getMountings()
    },
    delectMountingsLine() {
      this.form.mountingsList = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      this.condition.mountings.salesOrderId = ''
      this.condition.mountings.salesReturnOrderId = ''
      this.condition.mountings.productType = 1
      console.log(this.form.orderId)
      let reponse = {}
      if (this.form.deliveryType === 1) {
        this.condition.mountings.salesOrderId = this.form.orderId
        reponse = await getDetailedDataPopup(this.condition.mountings, this.pagination.mountings)
      } else if (this.form.deliveryType === 2) {
        this.condition.mountings.salesReturnOrderId = this.form.orderId
        reponse = await getReturnDetailsPopup(this.condition.mountings, this.pagination.mountings)
      } else if (this.form.deliveryType === 3) {
        this.condition.mountings.salesIndeterminateOrderId = this.form.orderId
        reponse = await getUnPricedDetailedPopup(this.condition.mountings, this.pagination.mountings)
      }

      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.mountingsList.splice(index, 1)
    },
    handleMountingsChange(val) {
      this.selection.mountings = val
    },
    mountingsConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
      } else {
        this.form.mountingsList = this.selection.mountings
      }
      for (const item of this.form.mountingsList) {
        item.salesOrderId = item.salesOrderId || item.id
        item.deliveryQty = item.undeliveredQuantity
        if (this.form.deliveryType === 2) {
          item.returnOrderLineId = item.id
        } else {
          item.returnOrderLineId = null
        }
      }
      const list = JSON.parse(JSON.stringify(this.form.mountingsList))
      this.$set(this.form, 'mountingsList', list)
      this.showObj.mountings = false
    },
    mountingsClose() {
      this.showObj.mountings = false
    },
    // 废料
    addFlotsamLine() {
      if (!this.form.orderId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售单号'
        })
        return
      }
      this.showObj.flotsam = true
      this.getFlotsam()
    },
    delectFlotsamLine() {
      this.form.flotsamList = []
    },
    async getFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      this.condition.flotsam.productType = 2
      let reponse = {}
      if (this.form.deliveryType === 1) {
        this.condition.flotsam.salesOrderId = this.form.orderId
        reponse = await getDetailedDataPopup(this.condition.flotsam, this.pagination.flotsam)
      } else if (this.form.deliveryType === 2) {
        this.condition.flotsam.salesReturnOrderId = this.form.orderId
        reponse = await getReturnDetailsPopup(this.condition.flotsam, this.pagination.flotsam)
      } else if (this.form.deliveryType === 3) {
        this.condition.flotsam.salesIndeterminateOrderId = this.form.orderId
        reponse = await getUnPricedDetailedPopup(this.condition.flotsam, this.pagination.flotsam)
      }
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    handleFlotsamDelete(index) {
      this.form.flotsamList.splice(index, 1)
    },
    handleFlotsamChange(val) {
      this.selection.flotsam = val
    },
    flotsamConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
      console.log(arr, this.selection.flotsam)

      if (arr !== null && arr.length > 0) {
        this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode', 'batch')
      } else {
        this.form.flotsamList = this.selection.flotsam
      }

      for (const item of this.form.flotsamList) {
        item.salesOrderId = item.salesOrderId || item.id
        item.deliveryQty = item.undeliveredQuantity
        if (this.form.deliveryType === 2) {
          item.returnOrderLineId = item.id
        } else {
          item.returnOrderLineId = null
        }
      }
      const list = JSON.parse(JSON.stringify(this.form.flotsamList))
      this.$set(this.form, 'flotsamList', list)
      console.log(list)
      this.showObj.flotsam = false
    },
    flotsamClose() {
      this.showObj.flotsam = false
    },
    // 配件明细
    addAccessoryDetailLine(item) {
      this.accessoryDetail.orderId = item.id
      this.accessoryDetail.deliveryType = item.deliveryType
      this.showObj.accessoryDetail = true
      this.getAccessoryDetail()
    },
    delectAccessoryDetailLine() {
      this.accessoryDetailList = []
    },
    async getAccessoryDetail(type = '') {
      if (type === 'refresh') {
        this.pagination.accessoryDetail.current = 1
      }
      this.loadingObj.accessoryDetail = true
      this.condition.accessoryDetail.salesOrderId = ''
      this.condition.accessoryDetail.salesReturnOrderId = ''
      // this.condition.accessoryDetail.productType = 1

      let reponse = {}

      if (this.accessoryDetail.deliveryType === 1) {
        this.condition.accessoryDetail.salesOrderId = this.accessoryDetail.orderId
        reponse = await getDetailedDataPopup(this.condition.accessoryDetail, this.pagination.accessoryDetail)
      } else if (this.accessoryDetail.deliveryType === 2) {
        this.condition.accessoryDetail.salesReturnOrderId = this.accessoryDetail.orderId
        reponse = await getReturnDetailsPopup(this.condition.accessoryDetail, this.pagination.accessoryDetail)
      } else if (this.accessoryDetail.deliveryType === 3) {
        this.condition.accessoryDetail.salesIndeterminateOrderId = this.accessoryDetail.orderId
        reponse = await getUnPricedDetailedPopup(this.condition.accessoryDetail, this.pagination.accessoryDetail)
      }

      const { current, total, size, records } = reponse.data
      this.dialog.accessoryDetail = records
      this.pagination.accessoryDetail.total = total
      this.pagination.accessoryDetail.current = current
      this.pagination.accessoryDetail.size = size
      this.loadingObj.accessoryDetail = false
    },
    handleAccessoryDetailDelete(index) {
      this.accessoryDetailList.splice(index, 1)
    },
    handleAccessoryDetailChange(val) {
      this.selection.accessoryDetail = val
    },
    AccessoryDetailConfirm() {
      const arr = JSON.parse(JSON.stringify(this.accessoryDetailList))
      if (arr !== null && arr.length > 0) {
        this.accessoryDetailList = mergeObjectArrayWithoutDuplicates(arr, this.selection.accessoryDetail, 'productCode')
      } else {
        this.accessoryDetailList = this.selection.accessoryDetail
      }
      // for (const item of this.accessoryDetailList) {
      //   item.salesOrderId = item.id
      //   item.deliveryQty = item.undeliveredQuantity

      //   if (this.form.deliveryType === 2) {
      //     item.returnOrderLineId = item.id
      //   } else {
      //     item.returnOrderLineId = null
      //   }
      // }
      this.showObj.accessoryDetail = false
    },
    accessoryDetailClose() {
      this.accessoryDetail = {}
      this.accessoryDetailList = []
      this.showObj.accessoryDetail = false
    },
    // 磅单重量
    selectNetWeight(index, type = '') {
      this.netWeightIndex = index
      // this.netWeightType = type
      this.showObj.netWeight = true
      this.getNetWeightDialog()
    },
    async getNetWeightDialog(type = '') {
      // if (type === 'refresh') {
      //   this.pagination.netWeight.current = 1
      // }
      this.loadingObj.netWeight = true
      const { companyInfoNumber } = this.$store.state.user.companyInfo
      this.condition.netWeight.sapFactoryCode = companyInfoNumber
      const { data } = await getWeightBillApi(this.condition.netWeight)

      this.dialog.netWeight = data
      // this.pagination.netWeight.total = total
      // this.pagination.netWeight.current = current
      // this.pagination.netWeight.size = size
      this.loadingObj.netWeight = false
    },
    handleNetWeightSelectionChange(val) {
      this.selection.netWeight = val
      console.log(this.selection.netWeight)
    },
    netWeightConfirm() {
      if (this.selection.netWeight.length > 1) {
        this.$message.warning('只能选择一个磅单重量！')
      } else {
        this.showObj.netWeight = false
        this.$set(this.form.flotsamList[this.netWeightIndex], 'netWeight', this.selection.netWeight[0].weighNet)
        this.$set(this.form.flotsamList[this.netWeightIndex], 'deliveryQty', this.selection.netWeight[0].weighNet)
        this.netWeightClose()
      }
    },
    netWeightClose() {
      this.showObj.netWeight = false
      this.netWeightIndex = null
    },
    cancelNetWeight(index) {
      this.$set(this.form.flotsamList[index], 'netWeight', null)
      this.$set(this.form.flotsamList[index], 'deliveryQty', null)
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        // this.form.mountingsList = []
        // this.form.flotsamList = []
        this.$set(this.form, 'mountingsList', [])
        this.$set(this.form, 'flotsamList', [])
        console.log(this.form.deliveryOrdersListVos)
        if (this.form.deliveryOrdersListVos && this.form.deliveryOrdersListVos.length > 0) {
          for (const item of this.form.deliveryOrdersListVos) {
            if (item.productType === 1) {
              this.form.mountingsList.push(item)
            } else {
              this.form.flotsamList.push(item)
            }
          }
        }
        if (this.form.deliveryType === 2) {
          this.rules.returnOrderSn[0].required = true
          this.rules.orderSn[0].required = false
        } else {
          this.rules.returnOrderSn[0].required = false
          this.rules.orderSn[0].required = true
        }
        if (this.form.mountingsList.length <= 0 && this.form.flotsamList.length > 0) {
          this.activePaneName = 'flotsam'
        }
        this.queryInvestment(this.form.orderId)
        this.loading = false
        // this.$nextTick(() => {
        //   this.$refs.elTable.doLayout()
        // })
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true
            const formData = JSON.parse(JSON.stringify(this.form))
            // 没有送达方就赋值成售达方
            // if (!formData.deliverySideId) {
            //   formData.deliverySideId = formData.soldToPartyId
            //   formData.deliverySideName = formData.soldToPartyName
            // }
            formData.deliveryOrderLineModels = formData.mountingsList.concat(formData.flotsamList)
            if (formData.deliveryOrderLineModels.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            delete formData.mountingsList
            delete formData.flotsamList
            const { message, data, code } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            this.editId = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    async confirmShipment() {
      this.$confirm('请先点击保存再确认发货', '提示', { type: 'warning', confirmButtonText: '已保存点击发货', cancelButtonText: '关闭' }).then(
        async () => {
          this.loading = true
          try {
            const res = await confirmShipmentApi({ id: this.form.id })
            this.getData()
            this.handleClose()
            this.loading = false
          } catch (err) {
            this.loading = false
          }
        }
      )
      // 先执行保存
      // await this.submitForm('form', false, async () => {
      //   // await this.getData();
      //   // 在执行提交

      // })
    }
    // flowLoad(e) {
    //   this.flowOptions = e
    //   this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    // },
    // 流程提交
    // async onComplete() {
    //   // 先执行保存
    //   await this.submitForm('form', false, async() => {
    //     // await this.getData();
    //     // 在执行提交
    //     await this.$refs.flow.onComplete()
    //     this.handleClose()
    //   })
    // },
    // 保存并提交
    // async saveAndSubmit() {
    //   // 先执行保存
    //   await this.submitForm('form', false, async() => {
    //     await this.submit()
    //   })
    // },
    // async submit() {
    //   try {
    //     this.loading = true
    //     const response = await submit(this.form.id)
    //     this.form.flowId = response.data.flowId
    //     this.loading = false
    //     this.handleClose()
    //     this.getData()
    //   } catch (error) {
    //     this.loading = false
    //   }
    // }
  }
}
</script>
    <style scoped>
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
</style>

